<div class="container" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
    <div class="no-data" [style.display]="noDataStyle">
        <span>No Data Found</span>
    </div>
    <ag-grid-angular style="width: 100%; height: 100%;-webkit-touch-callout: default;" class="ag-theme-balham"
        [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)"
        (selectionChanged)="onRowSelected($event)" (cellContextMenu)="onRowSelected($event)"
        (displayedColumnsChanged)="onDisplayedColumnsChanged($event)" (bodyScroll)="onBodyScroll($event)"
        (sortChanged)="onSortChanged($event)" [postProcessPopup]="onPostProcessPopup"
        (columnVisible)="onColumnVisible()" (columnResized)="onColumnResized()"
        (cellContextMenu)="onContextMenu($event)" (contextmenu)="suppressDefaultContextMenu($event)"
        (rowDoubleClicked)="onRowDoubleClicked($event)" (keydown)="onKeydown($event)">
        <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
    </ag-grid-angular>
</div>